import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MaterialModule } from './material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { Md2Module, NoConflictStyleCompatibilityMode } from 'md2';
import { CookieService } from 'ngx-cookie-service';
import { TextMaskModule } from 'angular2-text-mask';
import { DataTablesModule } from 'angular-datatables';
import { JsonSchemaFormModule, MaterialDesignFrameworkModule, JsonSchemaFormService, FrameworkLibraryService, WidgetLibraryService, Framework, MaterialDesignFramework } from 'angular2-json-schema-form';

import { EguardmatSidenavHelperDirective, EguardmatSidenavTogglerDirective } from '../directives/md-sidenav-helper/md-sidenav-helper.directive';
import { EguardPipesModule } from '../pipes/pipes.module';
import { EguardConfirmatialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { EguardCountdownComponent } from '../components/countdown/countdown.component';
import { EguardNavigationService } from '../components/navigation/navigation.service';
import { EguardValidationComponent } from '../components/validation/validation.component';
import { EguardValidationService } from '../components/validation/validation.service';
import { EguardMatchMedia } from '../services/match-media.service';
import { EguardNavbarVerticalService } from '../../main/shared/components/navbar/vertical/navbar-vertical.service';
import { EguardmatSidenavHelperService } from '../directives/md-sidenav-helper/md-sidenav-helper.service';
import { EguardIfOnDomatirective } from '../directives/eguard-if-on-dom/eguard-if-on-dom.directive';
import { EguardOnlyNumberDirective } from '../directives/onlynumber/onlynumber.directive';
import { EguardPerfectScrollbarDirective } from '../directives/eguard-perfect-scrollbar/eguard-perfect-scrollbar.directive';
import { EguardLimitNumber } from '../directives/limitnumber/limitnumber.directive';
import { EguardMaterialColorPickerComponent } from '../components/material-color-picker/material-color-picker.component';
import { EguardToggleFullscreenDirective } from '../directives/toggle-full-screen/toggle-full-screen.directive';
import { NgcFloatButtonModule } from 'ngc-float-button';
import { CaseBackgroundComponent } from '../../main/shared/components/case-background/case-background.component';
import { EguardAutofocusDirective } from '../directives/eguard-autofocus/eguard-autofocus.directive';


@NgModule({
    declarations: [
        EguardmatSidenavHelperDirective,
        EguardmatSidenavTogglerDirective,
        EguardConfirmatialogComponent,
        EguardCountdownComponent,
        EguardValidationComponent,
        EguardIfOnDomatirective,
        EguardOnlyNumberDirective,
        EguardAutofocusDirective,
        EguardPerfectScrollbarDirective,
        EguardToggleFullscreenDirective,
        EguardLimitNumber,
        EguardMaterialColorPickerComponent,
        CaseBackgroundComponent
    ],
    imports: [
        FlexLayoutModule,
        MaterialModule,
        CommonModule,
        FormsModule,
        EguardPipesModule,
        PerfectScrollbarModule,
        ReactiveFormsModule,
        Md2Module,
        NoConflictStyleCompatibilityMode,
        TextMaskModule,
        DataTablesModule,
        MaterialDesignFrameworkModule,
        {
            ngModule: JsonSchemaFormModule,
            providers: [
                JsonSchemaFormService,
                FrameworkLibraryService,
                WidgetLibraryService,
                { provide: Framework, useClass: MaterialDesignFramework, multi: true }
            ]
        },
        EguardPipesModule
    ],
    exports: [
        FlexLayoutModule,
        MaterialModule,
        CommonModule,
        FormsModule,
        EguardmatSidenavHelperDirective,
        EguardOnlyNumberDirective,
        EguardPerfectScrollbarDirective,
        EguardLimitNumber,
        EguardmatSidenavTogglerDirective,
        EguardAutofocusDirective,
        EguardPipesModule,
        EguardCountdownComponent,
        EguardValidationComponent,
        PerfectScrollbarModule,
        ReactiveFormsModule,
        EguardIfOnDomatirective,
        EguardToggleFullscreenDirective,
        EguardMaterialColorPickerComponent,
        Md2Module,
        NoConflictStyleCompatibilityMode,
        TextMaskModule,
        DataTablesModule,
        JsonSchemaFormModule,
        NgcFloatButtonModule,
        CaseBackgroundComponent
    ],
    entryComponents: [
        EguardConfirmatialogComponent,
        CaseBackgroundComponent
    ],
    providers: [
        CookieService,
        EguardNavigationService,
        EguardValidationService,
        EguardMatchMedia,
        EguardNavbarVerticalService,
        EguardmatSidenavHelperService
    ]
})

export class SharedModule {

}



// WEBPACK FOOTER //
// ./src/app/core/modules/shared.module.ts